// extracted by mini-css-extract-plugin
module.exports = {"iconText":"iconText-module--iconText--377Xd","iconText__icon":"iconText-module--iconText__icon--2wAr4"};